// Custodian Analytics: the routes and the sidebar rows of `wealth.intelligence.custodian-analytics` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.intelligence.custodian-analytics',
    routes: [
        {
            frontend: 'view',
            path: 'custodian-analytics',
            lazy: () => import('@/pages/view/custodian-analytics/page'),
        },
    ],
    nav: [
        {
            frontend: 'view',
            key: 'custodian-analytics',
            label: 'Custodian Analytics',
            href: '/view/custodian-analytics',
            icon: 'Building2',
            group: 'intelligence',
            order: 330,
        },
    ],
});
